export const customFilterAndSearch = (
  filter: string,
  vulnerability: any,
  data: any[],
): boolean => {
  return data.some(field =>
    vulnerability[field]
      ?.toString()
      .toLowerCase()
      .includes(filter.toLocaleLowerCase()),
  );
};
